import { jsx, jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { PasswordInput as PasswordInput$1, InputGroup, Label, ErrorText } from "@betterment/style-closet-react";
import { useField, ErrorMessage } from "formik";
import * as Yup from "yup";
import zxcvbn from "zxcvbn";
import { w as withoutOutline } from "./WithoutOutline-_MwFlIvo.js";
const ZxcvbnPasswordInput = (props) => /* @__PURE__ */ jsx(PasswordInput$1, { name: "password", id: "password", role: "textbox", ...props, strengthEstimator: zxcvbn });
const isPasswordValueStrong = (password) => {
  const scoreValue = zxcvbn((password == null ? void 0 : password.substring(0, 100)) || "");
  if (!password || (scoreValue == null ? void 0 : scoreValue.score) < 4) return false;
  return true;
};
const PasswordSchema = Yup.string().required("Please enter your password").min(8, "").max(100, "Please limit password to 100 characters").test({
  message: "",
  test: isPasswordValueStrong
});
const PasswordInput = withoutOutline(ZxcvbnPasswordInput, true);
const PasswordInputGroup = ({
  formProps,
  setAssessment,
  value,
  label,
  fullWidth
}) => {
  const assess = useCallback(
    (passwordAssessment) => {
      setAssessment(passwordAssessment);
    },
    [setAssessment]
  );
  const reset = useCallback(
    (event) => {
      void formProps.setFieldValue("password", event.target.value);
    },
    [formProps]
  );
  const [field] = useField("password");
  return /* @__PURE__ */ jsxs(InputGroup, { maxWidth: "100%", mb: [2, 8, 9], fullWidth, children: [
    /* @__PURE__ */ jsx(Label, { htmlFor: "password", children: label || "Password" }),
    /* @__PURE__ */ jsx(
      PasswordInput,
      {
        ...field,
        id: "password",
        mb: "1",
        value,
        onEstimation: assess,
        onChange: reset,
        borderRadius: "0.3rem"
      }
    ),
    /* @__PURE__ */ jsx(ErrorMessage, { name: "password", component: ErrorText })
  ] });
};
export {
  PasswordInputGroup as P,
  PasswordSchema as a,
  isPasswordValueStrong as i
};
//# sourceMappingURL=PasswordInputGroup-DG4sHRWs.js.map
